"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlgoliaContext = void 0;
const react_1 = require("react");
const components_1 = require("../components");
const context_1 = require("../context");
const useAlgoliaContext = () => {
    const context = (0, react_1.useContext)(context_1.algoliaContext);
    if (context === undefined) {
        throw new Error(`${useAlgoliaContext.name} must be used within a ${components_1.AlgoliaContextProvider.name}`);
    }
    return context;
};
exports.useAlgoliaContext = useAlgoliaContext;
//# sourceMappingURL=useAlgoliaContext.js.map